import CloseIcon from '@mui/icons-material/Close';
import {
    Box,
    CardMedia,
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    Typography,
    useMediaQuery
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useState } from 'react';
import BAC_Financial from '../assets/BAC.png';
import BuyGroup from '../assets/BuyGroup.png';
import FutureVue from '../assets/FutureVue.png';
import photo from '../assets/HeadBack.webp';
import Liter from '../assets/Liter.png';
import projects from '../data/Projects.json';
import PageBanner from './SectionPageBanner';
const Project = () => {
  const [open, setOpen] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const imageMap = {
    Liter,
    FutureVue,
    BAC_Financial,
    BuyGroup
  }


  const handleOpen = (project) => {
    setSelectedProject(project);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedProject(null);
  };

  return (
    <Box sx={{ pb: 5, textAlign: 'center' }}>
       <PageBanner image={photo} title="See What's We Have Been Building" />
      <Box
        sx={{
          alignItems: 'center',
          justifyContent: 'center',
          // px: { xs: 2, sm: 3 },
          mx: 'auto',
          // mt:'40px',
          width: {
            xs: '95%',
            sm: '100%',
            md: '100%',
            lg: '85%',
            xl: '85%',
          },
          fontFamily: 'Nunito, sans-serif',
        }}
        maxWidth="lg">
        <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 4, mt: 4, fontWeight: 700 }}>
          From concept to creation, see how we bring ideas to life.
          Explore designs that define innovation and excellence.
        </Typography>

        <Grid container spacing={3} justifyContent="center" >
          {projects.map((project) => (
            <Grid item key={project.id} xs={12} sm={6} md={3}>
              <Box
                sx={{
                  position: 'relative',
                  borderRadius: 3,
                  overflow: 'hidden',
                  boxShadow: 3,
                  '&:hover .infoBox': {
                    transform: 'translateY(0)',
                  },
                }}
              >
                <CardMedia
                  component="img"
                  image={imageMap[project.image]}
                  alt={project.name}
                  loading="lazy"
                  sx={{
                    width: '100%',
                    height: '300px',
                    borderRadius: 3,
                  }}
                />

                {/* Slide-up Box */}
                <Box
                  className="infoBox"
                  sx={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    transform: 'translateY(100%)',
                    transition: 'transform 0.5s ease-in-out',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-end',
                    background: 'transparent',
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: 'white',
                      color: '#0d0d0d',
                      borderRadius: 2,
                      padding: 4,
                      marginRight:'20%',
                      width: '60%',
                      textAlign: 'left',
                      boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
                      borderBottomLeftRadius: 0,
                      borderBottomRightRadius: 0,
                    }}
                  >
                    <Typography
                      variant="caption"
                      sx={{ color: '#5c6bc0', textTransform: 'uppercase', fontWeight: "600", fontSize: '15px', fontFamily: 'Rajdhani' }}
                    >
                      DESIGN
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 'bold',
                        fontFamily: 'Rajdhani',
                        mt: 0.5,
                        cursor: 'pointer',
                        transition: 'color 0.3s ease',
                        '&:hover': {
                          color: '#1976d2',
                        },
                      }}
                      onClick={() => window.location.href = project?.website}

                    >
                      {project.name}
                    </Typography>

                    {/* <Typography
        variant="body2"
        onClick={() => handleOpen(project)}
        sx={{
          color: '#1976d2',
          textDecoration: 'underline',
          mt: 0.5,
          fontWeight: 500,
          cursor: 'pointer',
        }}
      >
        {project.readMore}
      </Typography> */}
                  </Box>
                </Box>
              </Box>

            </Grid>
          ))}
        </Grid>

        {/* Dialog Popup */}
        <Dialog
          open={open}
          onClose={handleClose}
          fullScreen={fullScreen}
          maxWidth={false}
          PaperProps={{
            sx: {
              width: '70%',
              height: '50vh',
              m: 'auto', // center the dialog
              display: 'flex',
              flexDirection: 'column',
            },
          }}
        >
          <DialogTitle sx={{ m: 0, p: 2, fontWeight: '700' }}>
            {selectedProject?.name}
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 1,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent
            dividers
            sx={{
              overflowY: 'auto',
              flexGrow: 1,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
            }}
          >
            <Box>
              <Typography variant="subtitle1" gutterBottom>
                {/* Role: {selectedProject?.readMore} */}
              </Typography>
              <Typography variant="body1" sx={{ mb: 1, fontFamily: 'Nunito, sans-serif' }}>
                {selectedProject?.description}
              </Typography>

              {/* Optional Stack Section
      <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
        Tech Stack:
      </Typography>
      <ul>
        {selectedProject?.stacks?.map((tech, index) => (
          <li key={index}>{tech}</li>
        ))}
      </ul>
      */}
            </Box>

            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: 'bold',
                textAlign: 'center',
                pt: 2,
                pb: 2,
              }}
            >
              {selectedProject?.website}
            </Typography>
          </DialogContent>
        </Dialog>
      </Box>
    </Box>
  );
};

export default Project;
